import React from "react";
import { Modal } from "semantic-ui-react";

const Confirm = ({ open, onConfirm, onCancel, message }) => {
  return (
    <Modal
      size="mini"
      open={open}
      //onClose={onCancel}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      style={{ top: "auto" }} // for positioning of modal at center of view port
    >
      <Modal.Content className="border">
        <div className="px-20">
          <h6>Do You Want To Delete ?</h6>
          <h6>{message}</h6>
        </div>
        <div className="flex-center mb-15">
          <span
            className="btntask"
            style={{ background: "#cc3333" }}
            onClick={onConfirm}
          >
            Delete
          </span>
          <span className="btntask" onClick={onCancel}>
            Cancel
          </span>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default Confirm;
